import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-forest-dark">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-amber-brand border-t-transparent" />
      </div>
    );
  }
  if (!user || !user.is_admin) return <Navigate to="/admin" state={{ from: location }} replace />;
  return children;
}
